import { useMusicContext } from "@/providers/MusicProvider";
import type { MusicKey } from "@/lib/audio/musicMap";

/** Imperative music API. */
export function useMusic() {
  return useMusicContext();
}

export type { MusicKey };